/**
 * auth.js — Orak OTP Authentication
 * Flow : email → code 6 chiffres → JWT Railway → espace client
 */
(function () {
  'use strict';

  var APP_URL = window.ORAK_APP_URL || '';
  var REDIRECT = (window.ORAK_ROOT || '') + '/pages/espace-client';
  var currentEmail = { login: '', register: '' };
  var resendTimers = {};

  /* ══════════════════════════════════════
     INIT
  ══════════════════════════════════════ */

  function init() {
    // Déjà connecté → rediriger directement
    if (APP_URL && localStorage.getItem('orak_session')) {
      window.location.replace(REDIRECT);
      return;
    }

    // Onglet par défaut via URL (?register=1)
    var params = new URLSearchParams(window.location.search);
    if (params.get('register') === '1') {
      switchAuthTab('register');
    }

    // Bind domain validation sur login-email aussi
    var loginEmail = document.getElementById('login-email');
    if (loginEmail) {
      loginEmail.addEventListener('input', function () {
        validateDomain(this, 'login-domain-status', 'login-domain-icon', 'login-domain-msg');
      });
      loginEmail.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); otpRequest('login'); }
      });
    }
  }

  /* ══════════════════════════════════════
     TAB SWITCHER
  ══════════════════════════════════════ */

  window.switchAuthTab = function (tab) {
    document.getElementById('view-login').style.display    = tab === 'login'    ? '' : 'none';
    document.getElementById('view-register').style.display = tab === 'register' ? '' : 'none';
    document.getElementById('tab-login').classList.toggle('active',    tab === 'login');
    document.getElementById('tab-register').classList.toggle('active', tab === 'register');
    history.replaceState(null, '', tab === 'register' ? '?register=1' : window.location.pathname);
  };

  /* ══════════════════════════════════════
     DOMAIN VALIDATION
  ══════════════════════════════════════ */

  var PUBLIC_DOMAINS = [
    'gmail.com','googlemail.com','hotmail.fr','hotmail.com','hotmail.be',
    'outlook.fr','outlook.com','outlook.be','yahoo.fr','yahoo.com','yahoo.be',
    'live.fr','live.com','live.be','icloud.com','me.com','mac.com',
    'laposte.net','orange.fr','sfr.fr','free.fr','wanadoo.fr',
    'numericable.fr','bbox.fr','bouygtel.fr',
    'aol.com','gmx.com','gmx.fr','protonmail.com','proton.me',
    'tutanota.com','yandex.com','yandex.fr','mail.com','inbox.com'
  ];

  window.validateDomain = function (inp, statusId, iconId, msgId) {
    var status = document.getElementById(statusId);
    var icon   = document.getElementById(iconId);
    var msg    = document.getElementById(msgId);
    if (!status || !icon || !msg) return true;

    var parts = inp.value.trim().split('@');
    if (parts.length !== 2 || !parts[1] || !parts[1].includes('.')) {
      status.className = 'domain-status';
      inp.classList.remove('error');
      return true;
    }

    var domain = parts[1].toLowerCase();
    if (PUBLIC_DOMAINS.indexOf(domain) !== -1) {
      status.className = 'domain-status show bad';
      icon.className   = 'ti ti-x';
      msg.textContent  = "Merci d'utiliser votre email professionnel";
      inp.classList.add('error');
      return false;
    }

    status.className = 'domain-status show ok';
    icon.className   = 'ti ti-check';
    msg.textContent  = 'Email professionnel reconnu';
    inp.classList.remove('error');
    return true;
  };

  /* ══════════════════════════════════════
     OTP REQUEST — envoyer le code
  ══════════════════════════════════════ */

  window.otpRequest = function (mode) {
    if (!APP_URL) { showError(mode, 1, 'Configuration manquante, contactez Orak.'); return; }

    var emailId  = mode === 'login' ? 'login-email' : 'reg-email';
    var emailEl  = document.getElementById(emailId);
    var email    = emailEl ? emailEl.value.trim().toLowerCase() : '';

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(mode, 1, 'Veuillez saisir un email valide.');
      if (emailEl) emailEl.focus();
      return;
    }

    // Bloquer les emails grand public
    var domainStatusId = mode === 'login' ? 'login-domain-status' : 'reg-domain-status';
    var domainIconId   = mode === 'login' ? 'login-domain-icon'   : 'reg-domain-icon';
    var domainMsgId    = mode === 'login' ? 'login-domain-msg'    : 'reg-domain-msg';
    if (emailEl && !validateDomain(emailEl, domainStatusId, domainIconId, domainMsgId)) {
      showError(mode, 1, "Merci d'utiliser votre email professionnel.");
      if (emailEl) emailEl.focus();
      return;
    }

    var btnId  = mode === 'login' ? 'login-btn-1' : 'register-btn-1';
    var btn    = document.getElementById(btnId);
    setLoading(btn, true, 'Envoi en cours…');
    clearError(mode, 1);

    var body = { email: email, mode: mode };
    if (mode === 'register') {
      body.first_name = (document.getElementById('reg-first-name') || {}).value || '';
      body.last_name  = (document.getElementById('reg-last-name')  || {}).value || '';
      body.company    = (document.getElementById('reg-company')    || {}).value || '';
    }

    fetch(APP_URL + '/auth/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
    .then(function (res) {
      setLoading(btn, false);
      if (!res.ok) {
        showError(mode, 1, res.data.error || 'Impossible d\'envoyer le code.');
        return;
      }
      currentEmail[mode] = email;
      goToStep2(mode);
      startResendTimer(mode, 60);
    })
    .catch(function () {
      setLoading(btn, false);
      showError(mode, 1, 'Erreur réseau. Vérifiez votre connexion.');
    });
  };

  /* ══════════════════════════════════════
     OTP VERIFY — valider le code
  ══════════════════════════════════════ */

  window.otpVerify = function (mode) {
    var code = getOtpCode(mode);
    if (code.length < 6) {
      showError(mode, 2, 'Entrez les 6 chiffres du code.');
      return;
    }

    var btnId = mode === 'login' ? 'login-btn-2' : 'register-btn-2';
    var btn   = document.getElementById(btnId);
    setLoading(btn, true, 'Vérification…');
    clearError(mode, 2);

    fetch(APP_URL + '/auth/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: currentEmail[mode], code: code })
    })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
    .then(function (res) {
      setLoading(btn, false);
      if (!res.ok) {
        showError(mode, 2, res.data.error || 'Code incorrect.');
        shakeBoxes(mode);
        return;
      }
      localStorage.setItem('orak_session',  res.data.token);
      localStorage.setItem('orak_customer', JSON.stringify(res.data.customer || {}));
      window.location.replace(REDIRECT);
    })
    .catch(function () {
      setLoading(btn, false);
      showError(mode, 2, 'Erreur réseau. Vérifiez votre connexion.');
    });
  };

  /* ══════════════════════════════════════
     OTP RESEND
  ══════════════════════════════════════ */

  window.otpResend = function (mode) {
    var email = currentEmail[mode];
    if (!email) { otpBack(mode); return; }

    var resendBtn   = document.getElementById(mode + '-resend-btn');
    var resendTimer = document.getElementById(mode + '-resend-timer');
    if (resendBtn) resendBtn.style.display = 'none';
    clearError(mode, 2);

    fetch(APP_URL + '/auth/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, mode: mode })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (resendTimer) {
        resendTimer.textContent = 'Code renvoyé !';
        resendTimer.style.display = 'inline';
        setTimeout(function () {
          resendTimer.style.display = 'none';
          startResendTimer(mode, 60);
        }, 2000);
      }
      clearOtpBoxes(mode);
      focusFirstBox(mode);
    })
    .catch(function () {
      if (resendBtn) resendBtn.style.display = 'inline';
    });
  };

  /* ══════════════════════════════════════
     BACK / STEP NAVIGATION
  ══════════════════════════════════════ */

  window.otpBack = function (mode) {
    document.getElementById(mode + '-step-1').style.display = '';
    document.getElementById(mode + '-step-2').style.display = 'none';
    clearError(mode, 1);
    clearError(mode, 2);
    clearOtpBoxes(mode);
    var emailId = mode === 'login' ? 'login-email' : 'reg-email';
    var el = document.getElementById(emailId);
    if (el) { el.focus(); el.select(); }
    if (resendTimers[mode]) { clearInterval(resendTimers[mode]); }
  };

  function goToStep2(mode) {
    document.getElementById(mode + '-step-1').style.display = 'none';
    document.getElementById(mode + '-step-2').style.display = '';
    var disp = document.getElementById(mode + '-email-display');
    if (disp) disp.textContent = currentEmail[mode];
    clearOtpBoxes(mode);
    focusFirstBox(mode);
  }

  /* ══════════════════════════════════════
     OTP BOXES — gestion clavier & paste
  ══════════════════════════════════════ */

  window.otpInput = function (e, mode) {
    var inp = e.target;
    var val = inp.value.replace(/\D/g, '');
    inp.value = val ? val[0] : '';
    if (val) {
      var next = getBox(mode, parseInt(inp.dataset.idx, 10) + 1);
      if (next) next.focus();
      else checkAutoVerify(mode);
    }
  };

  window.otpKey = function (e, mode) {
    var inp = e.target;
    var idx = parseInt(inp.dataset.idx, 10);
    if (e.key === 'Backspace') {
      if (!inp.value) {
        var prev = getBox(mode, idx - 1);
        if (prev) { prev.value = ''; prev.focus(); }
      }
    } else if (e.key === 'ArrowLeft') {
      var prevEl = getBox(mode, idx - 1);
      if (prevEl) prevEl.focus();
    } else if (e.key === 'ArrowRight') {
      var nextEl = getBox(mode, idx + 1);
      if (nextEl) nextEl.focus();
    } else if (e.key === 'Enter') {
      otpVerify(mode);
    }
  };

  window.otpPaste = function (e, mode) {
    e.preventDefault();
    var text = (e.clipboardData || window.clipboardData).getData('text');
    var digits = text.replace(/\D/g, '').slice(0, 6);
    for (var i = 0; i < 6; i++) {
      var box = getBox(mode, i);
      if (box) box.value = digits[i] || '';
    }
    var last = getBox(mode, Math.min(digits.length, 5));
    if (last) last.focus();
    checkAutoVerify(mode);
  };

  function getBox(mode, idx) {
    var wrap = document.getElementById(mode + '-otp-boxes');
    if (!wrap || idx < 0 || idx > 5) return null;
    return wrap.querySelectorAll('.otp-box')[idx] || null;
  }

  function getOtpCode(mode) {
    var code = '';
    for (var i = 0; i < 6; i++) {
      var box = getBox(mode, i);
      code += box ? (box.value || '') : '';
    }
    return code;
  }

  function clearOtpBoxes(mode) {
    for (var i = 0; i < 6; i++) {
      var box = getBox(mode, i);
      if (box) { box.value = ''; box.classList.remove('error'); }
    }
  }

  function focusFirstBox(mode) {
    setTimeout(function () { var b = getBox(mode, 0); if (b) b.focus(); }, 80);
  }

  function checkAutoVerify(mode) {
    if (getOtpCode(mode).length === 6) {
      setTimeout(function () { otpVerify(mode); }, 180);
    }
  }

  function shakeBoxes(mode) {
    var wrap = document.getElementById(mode + '-otp-boxes');
    if (!wrap) return;
    wrap.classList.add('otp-shake');
    var boxes = wrap.querySelectorAll('.otp-box');
    boxes.forEach(function (b) { b.classList.add('error'); });
    setTimeout(function () {
      wrap.classList.remove('otp-shake');
      boxes.forEach(function (b) { b.classList.remove('error'); });
      clearOtpBoxes(mode);
      focusFirstBox(mode);
    }, 600);
  }

  /* ══════════════════════════════════════
     RESEND TIMER
  ══════════════════════════════════════ */

  function startResendTimer(mode, seconds) {
    var resendBtn   = document.getElementById(mode + '-resend-btn');
    var resendTimer = document.getElementById(mode + '-resend-timer');
    if (!resendBtn || !resendTimer) return;

    resendBtn.style.display  = 'none';
    resendTimer.style.display = 'inline';
    var left = seconds;

    function tick() {
      resendTimer.textContent = 'Renvoyer dans ' + left + 's';
      if (left <= 0) {
        clearInterval(resendTimers[mode]);
        resendTimer.style.display = 'none';
        resendBtn.style.display  = 'inline';
      }
      left--;
    }
    tick();
    resendTimers[mode] = setInterval(tick, 1000);
  }

  /* ══════════════════════════════════════
     UI HELPERS
  ══════════════════════════════════════ */

  function showError(mode, step, msg) {
    var el = document.getElementById(mode + '-error-' + step);
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
  }

  function clearError(mode, step) {
    var el = document.getElementById(mode + '-error-' + step);
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  function setLoading(btn, loading, label) {
    if (!btn) return;
    btn.disabled = loading;
    if (loading) {
      btn.dataset.original = btn.innerHTML;
      btn.innerHTML = '<span class="btn-spinner"></span>' + (label || 'Chargement…');
    } else {
      btn.innerHTML = btn.dataset.original || btn.innerHTML;
    }
  }

  /* ══════════════════════════════════════
     PASSWORD TOGGLE (héritage)
  ══════════════════════════════════════ */

  window.togglePwd = function (inputId, iconId) {
    var inp = document.getElementById(inputId);
    var ico = document.getElementById(iconId);
    if (!inp || !ico) return;
    inp.type = inp.type === 'password' ? 'text' : 'password';
    ico.className = ico.className.includes('ti-lock-open')
      ? ico.className.replace('ti-lock-open', 'ti-lock')
      : ico.className.replace('ti-lock', 'ti-lock-open');
  };

  /* ══════════════════════════════════════
     BOOT
  ══════════════════════════════════════ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
